import React from 'react'
import { Card, Col, Row, Typography, Icon, Button } from 'antd';
import Lines from 'react-lines-ellipsis'
import { changeFormatdate, changeFormatdateStartEnd } from '../../../utils/formatdate'

import {
    BrowserRouter as Router,
    Link,
    Route
} from 'react-router-dom'
import {decodeBase64} from '../../../utils/base64File'

const { Meta } = Card;
const { Text, Title } = Typography
class CourseDetail extends React.PureComponent {

    checkStatus = (value) =>{
        if(value == 'PUBLIC'){
            return <>
                        <Icon type="global" className="mr-2" />
                        สาธารณะ
                    </>
        }else if(value == 'INTERNAL'){
            return  <>
                        <Icon type="team" className="mr-2" />
                        ภายใน
                    </>
        }else if(value == 'PRIVATE'){
            return 'ยังไม่เผยแพร่'
        }
    }

    renderBox = (detailBox, limit) => {
        console.log(detailBox);
        let readmoreText = "อ่านต่อ >>";
        let collumn = 8
        if (limit == 1) {
            collumn = 24
        }

        // console.log(detailBox)
        return (
            <>
                {               
                     detailBox.length !== 0 &&
                        detailBox.map(value => (
                            <>
                                {
                                    value.type == 'VTRC' ?
                                        <Link
                                            to={{
                                                pathname: '/course/WORK/' + value.courseId
                                            }}
                                        >
                                            { this.detailBoxHMTL(value, collumn, `[${value.type}] `) }
                                        </Link>
                                    :
                                        <a href={value.link} target="_blank">
                                            { this.detailBoxHMTL(value, collumn, `[${value.type}] `) }
                                        </a>
                                    // value.fileData &&
                                }
                            </>
                            
                     ))
                }
            </>
           
        )
    }

    detailBoxHMTL = (value, collumn, titleTpye) =>{
        return <>
                <Col span={collumn}>
                    <div className="">
                        <div className="uiMediaThumb">
                            {
                                value.type == 'VTRC' ?
                                    value.fileData &&
                                    <i className="uiMediaThumbImg" style={{ backgroundImage:"url(data:"+value.fileData.fileMimeType+"/gif;base64,"+value.fileData.fileId+")", }}></i>
                                :
                                    <i className="uiMediaThumbImg" style={{ backgroundImage:"url("+value.linkImage+")" }}></i>
                            }
                        </div>
                    </div>
                    <Card
                        hoverable
                        className="border-crad-custom"
                    >
                        <Row >
                            <div className="word-wrap ">
                                <Title level={4} className="mr-2 pr-1 mb-1 fick-height-header" style={{ display: "inline-block"}}>
                                    { ((titleTpye+value.title).length > '50') ? 
                                        (((value.title).substring(0,'50'-3)) + '...') : 
                                        titleTpye+value.title 
                                    }
                                </Title>
                                <br></br>
                            </div>
                            <div className="mb-1">
                                <Row>
                                    <Col xs={23} md={23} className="word-wrap">
                                        <div className="mt-2">
                                            <Text className="font-italic" style={{ color: '#FEB12A' }}>
                                            <span className="ml-1">วันที่ {changeFormatdateStartEnd(value.startDate)} </span>
                                                {
                                                    value.endDate &&
                                                    <>
                                                    - วันที่ {changeFormatdateStartEnd(value.endDate)}
                                                    </>
                                                }
                                            </Text>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <Col style={{ height: '50px' }} className="gutter-row" span={24} className="my-4">
                                <div className="mb-2 mt-3">
                                    <Button type="danger" className="btn-link-page">
                                        รายละเอียด <Icon type="arrow-right" />
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </>
    }

    render() {
        const { picnews, detailBox, limit } = this.props
        console.log(detailBox)
        return (
            <div className="site-card-wrapper">
                {detailBox.length !== 0 &&
                    <Row gutter={16}>
                        {this.renderBox(detailBox, limit)}
                    </Row>
                    ||
                    <>
                        <div style={{textAlign:"center"}}>
                            <Text className="color-gray"  >ไม่พบข้อมูล</Text>
                        </div>
                        <hr className="mt-4" />
                    </>
                }
            </div>
        )
    }
}

export default CourseDetail